import React from 'react';
import { Collapse, Button, Typography } from '@mui/material';
import { capitalize } from '../../../../../../shared/StringExtensions';
import OrderCollectionList, { IOrderCollection } from './OrderCollectionList';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

type OrderCollectionSectionProps = {
    title: string;
    isOpen: boolean;
    setIsOpen: () => void;
    orderCollections: IOrderCollection[];
    user: any;
    navigateTo: (route: string) => void;
    newOrderId: number | null;
};

function OrderCollectionSection({
    title,
    isOpen,
    setIsOpen,
    orderCollections,
    user,
    navigateTo,
    newOrderId
}: OrderCollectionSectionProps) {
    return (
        <div className="orderCollectionSection__container">
            <Button
                className="orderCollectionSection__headingToggleButton"
                onClick={() => setIsOpen()}
                sx={{ textTransform: 'none', justifyContent: 'flex-start' }}
            >
                <div className="orderCollectionSection__headerContainer">
                    <Typography variant="h5" component="h2">
                        {capitalize(title)}
                    </Typography>
                    {isOpen ? (
                        <ExpandMoreIcon className="orderCollectionSection__expandCollapseIcon" />
                    ) : (
                        <ExpandLessIcon className="orderCollectionSection__expandCollapseIcon" />
                    )}
                </div>
            </Button>
            <Collapse in={isOpen} unmountOnExit>
                <OrderCollectionList
                    items={orderCollections}
                    user={user}
                    navigateTo={navigateTo}
                    newOrderId={newOrderId}
                />
            </Collapse>
        </div>
    );
}

export default OrderCollectionSection;